function FeedPostBackHeadline({
  headline,
  className
}: {
  headline: string
  className: string
}) {
  return (
    <h1 className={`${className} text-4xl font-semibold font-serif word-break`}>
      {headline}
    </h1>
  )
}

export default FeedPostBackHeadline
